import React from 'react';
import { Container } from './styles/Container.styled';
import {
  KeyBenefitsSection,
  SectionCaption,
  KeyContent,
  KeyColumn,
  LiKey,
} from './styles/KeyBenefitsBlock.styled';
import { KeyBenefitsInnerSection } from './styles/KeyBenefitsInnerBlock.styled';
import CheckmarkBullet from '../assets/svg/checkmarkround.svg';

export default function Benefits({ data, id, dir }) {
  return (
    <KeyBenefitsInnerSection id={`${`${id}999`}`}>
      <KeyBenefitsSection id={id} dir={dir}>
        <Container>
          <SectionCaption className="benefits_caption" dir={dir}>
            <h2 dir={dir}>{data.title}</h2>
          </SectionCaption>
          <KeyContent>
            <KeyColumn>
              {data.benefits.map((item, i) => (
                <LiKey dir={dir} key={i}>
                  <span dir={dir}>
                    <CheckmarkBullet />
                  </span>{' '}
                  <span className="second_span" dir={dir}>
                    {item}
                  </span>
                </LiKey>
              ))}
            </KeyColumn>
          </KeyContent>
        </Container>
      </KeyBenefitsSection>
    </KeyBenefitsInnerSection>
  );
}
